import { Component, effect, ElementRef, inject, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { Identity, PreviewContext } from '@xanadu/model';
import { AuthSignal, PreviewSignal } from '@xanadu/signal';

@Component({
    selector: 'app-screen',
    templateUrl: './screen.component.html',
    styleUrls: ['./screen.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScreenComponent {
    private readonly previewSignal = inject(PreviewSignal);
    private readonly authSignal = inject(AuthSignal);
    private readonly frame = viewChild<ElementRef<HTMLIFrameElement>>('frame');

    previewContext?: PreviewContext;
    identity: Identity | undefined;

    current?: string;

    firstOpen: boolean = false;

    constructor() {
        effect(() => {
            const context = this.previewSignal.context();

            if (context) {
                this.previewContext = context;
                this.firstOpen = true;
            } else {
                this.previewContext = undefined;
                this.firstOpen = false;
            }
        });

        effect(() => {
            const identity = this.authSignal.identity();

            if (identity) {
                this.identity = identity;
            }
        });
    }

    onPreview(key: string, url: string): void {
        this.current = key;

        const frame = this.frame();
        if (frame) {
            frame.nativeElement.src = url + (url.includes('?') ? '&' : '?') + 'previewToken=' + this.identity?.token;
        }
    }
}
